import React from 'react';
import Gauge from '../ui/Gauge';
import { Observe } from 'rewire-core';
import { WithStyle } from 'rewire-ui';
import { Theme } from '@material-ui/core/styles';
import { IDashboardElementProps } from './DashboardElementModel';
import { makeStyles } from '../utility/styles';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '../utility/styles';

const styles = (_theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    minWidth: '110px',
  },
  name: {
    fontSize: '18px',
    color: '#0f5c71',
    fontWeight: '500',
    textTransform: 'uppercase',
  },
  value: {
    fontSize: '34px',
    fontWeight: 'bold',
    color: 'black',
  },
});

interface IBatchDashboardCardProps {
  model: IDashboardElementProps;
}

type BatchDashboardCardProps = WithStyle<ReturnType<typeof styles>, IBatchDashboardCardProps>;

const useCardStyle = makeStyles(styles);

export const BatchDashboardPlainCard = (props: IBatchDashboardCardProps) => {
  const classes = useCardStyle();
  return (
    <Observe
      render={() => {
        return (
          <div className={classes.root}>
            <Typography className={classes.name}>{props.model.name}</Typography>
            <Typography className={classes.value}>{props.model.formattedValue}</Typography>
          </div>
        );
      }}
    />
  );
};

class BatchDashboardCardView extends React.PureComponent<BatchDashboardCardProps> {
  constructor(props: BatchDashboardCardProps) {
    super(props);
  }

  render() {
    if (this.props.model.visible === false) {
      return null;
    }
    const topLabelStyle = {
      fill: '#0f5c71',
    };

    return (
      <Observe
        render={() => {
          const { model } = this.props;

          return (
            <Gauge
              value={model.value}
              valueFormatter={(_value: number) => model.formattedValue!}
              max={model.maxValue}
              label={model.name}
              height={130}
              width={180}
              color={model.color}
              topLabelStyle={topLabelStyle}
            />
          );
        }}
      />
    );
  }
}

export default withStyles<IBatchDashboardCardProps>(styles, BatchDashboardCardView);
